import * as React from 'react';
import { SVGProps } from 'react';

const IconJiraSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M20.266 3H11.8c0 1.017.403 1.992 1.12 2.71a3.815 3.815 0 0 0 2.701 1.123h1.56v1.51A3.827 3.827 0 0 0 21 12.173V3.738A.735.735 0 0 0 20.266 3Z" />
    <path d="M15.876 7.434H7.412a3.827 3.827 0 0 0 3.818 3.83h1.56v1.516a3.827 3.827 0 0 0 3.82 3.828V8.17a.736.736 0 0 0-.734-.737Z" />
    <path d="M11.464 11.826H3a3.827 3.827 0 0 0 3.821 3.833h1.564v1.51A3.827 3.827 0 0 0 12.2 21v-8.437a.736.736 0 0 0-.735-.737Z" />
  </svg>
);
export default IconJiraSizeM;
